import React, { useContext } from "react";
import 'rc-slider/assets/index.css';
import LandItem from "./landItem";
import { TownContext } from "../../shared/townContext";

const BuyLandItem = ({ town, type, maxArea }) => {
  let { property } = useContext(TownContext)

  return <LandItem type={type} maxArea={maxArea} action='buy'
                   route={`/students/towns/${town.id}/properties/${property.id}/${type}`} />
}

export default BuyLandItem
